export class SystemStatusDto {
    isWorkingProperly: boolean;
    message: string;
    count?: number;
}